// Global utils
import "./Modules/Utils/UtilsApp";
import { BrowserCheck } from "App/Modules/Utils";
import "./Modules/Utils/Services/Config/EnvBasedConfigApp";

new BrowserCheck().checkBrowserAndOutputWarning();

/* eslint-disable import/first */
import "./Core/App";
import "./Core/Bootstrap";

import "./Modules/Models/ModelsApp";

// Repositories
import "./Modules/Repositories/RepositoriesApp";
import "./Modules/Repositories/Alarm/AlarmsRepository";
import "./Modules/Repositories/AlarmCentral/AlarmCentralsRepository";
import "./Modules/Repositories/AlarmEvent/AlarmEventsRepository";
import "./Modules/Repositories/AlarmHandling/AlarmHandlingRepository";
import "./Modules/Repositories/Company/CompaniesRepository";
import "./Modules/Repositories/Country/CountriesRepository";
import "./Modules/Repositories/EnvironmentConfiguration/EnvironmentConfigurationRepository";
import "./Modules/Repositories/Equipment/EquipmentRepository";
import "./Modules/Repositories/EquipmentFunctionalityType/EquipmentFunctionalityTypesRepository";
import "./Modules/Repositories/EquipmentType/EquipmentTypeRepository";
import "./Modules/Repositories/EventReport/EventReportsRepository";
import "./Modules/Repositories/Events/EventsRepository";
import "./Modules/Repositories/GuardCompany/GuardCompaniesRepository";
import "./Modules/Repositories/Issue/IssuesRepository";
import "./Modules/Repositories/Locale/LocalesRepository";
import "./Modules/Repositories/Manufacturer/ManufacturersRepository";
import "./Modules/Repositories/Partner/PartnersRepository";
import "./Modules/Repositories/PartnerUser/PartnerUsersRepository";
import "./Modules/Repositories/Role/RolesRepository";
import "./Modules/Repositories/Search/SearchRepository";
import "./Modules/Repositories/Site/SitesRepository";
import "./Modules/Repositories/SiteEquipment/SiteEquipmentRepository";
import "./Modules/Repositories/SiteFunctionalities/SiteFunctionalitiesRepository";
import "./Modules/Repositories/SiteVideoStreams/SiteVideoStreamsRepository";
import "./Modules/Repositories/Teams/TeamsRepository";
import "./Modules/Repositories/TimeZone/TimeZonesRepository";
import "./Modules/Repositories/TranslationKeys/TranslationKeysRepository";
import "./Modules/Repositories/Translations/TranslationsRepository";
import "./Modules/Repositories/NotificationConfigurations/NotificationConfigurationsRepository";

// Services
import "./Services/EquipmentList/SiteEquipmentListService";
import "./Services/Masonry/MasonryService";
import "./Services/SiteMenu/SiteMenuItemsServiceApp";
import "./Modules/Models/Services/Enum/EnumService";

import "./Modules/Services/ServicesApp";
import "./Modules/Services/DefaultNaming/DefaultNamingService";
import "./Modules/Services/FeatureFlag/FeatureFlagService";
import "./Modules/Services/FormContainer/Modal/ModalService";
import "./Modules/Services/Http/HttpService";
import "./Modules/Services/HttpInterceptors/HttpInterceptors";
import "./Modules/Services/Image/ImageService";
import "./Modules/Services/IpValidation/IpValidationService";
import "./Modules/Services/Screen/ScreenService";
import "./Modules/Services/ServiceWorker/ServiceWorkerService";
import "./Modules/Services/HumanizeDuration/HumanizeDurationService";
import "./Modules/Services/Page/PageService";
import "./Modules/Services/Validation/ValidationService";

// Auth
import "./Modules/Auth/AuthApp";
import "./Modules/Auth/Repositories/Account/AccountRepositoryApp";
import "./Modules/Auth/Repositories/Profile/ProfileRepositoryApp";
import "./Modules/Auth/Repositories/Token/TokenRepositoryApp";
import "./Modules/Auth/Components/LoginForm/LoginFormComponentApp";
import "./Modules/Auth/Components/LoginForm/UnauthorizedModal/UnauthorizedModalComponentApp";
import "./Modules/Auth/Components/Profile/ProfileComponentApp";
import "./Modules/Auth/Components/ResetPassword/ConfirmReset/ConfirmPasswordResetComponentApp";
import "./Modules/Auth/Components/ResetPassword/RequestReset/RequestPasswordResetComponentApp";
import "./Modules/Auth/Components/UserVerification/Cancel/CancelVerificationComponentApp";
import "./Modules/Auth/Components/UserVerification/Confirm/ConfirmVerificationComponentApp";
import "./Modules/Auth/Directives/IrisityBackgroundWrapper/IrisityBackgroundWrapperDirectiveApp";
import "./Modules/Auth/Services/HttpAuthInterceptor/HttpAuthInterceptorApp";
import "./Modules/Auth/Services/Login/LoginServiceApp";
import "./Modules/Auth/Services/Profile/ProfileServiceApp";
import "./Modules/Auth/Services/Token/TokenServiceApp";
import "./Modules/Auth/Services/TokenHolder/TokenHolderServiceApp";

// Globalisation
import "./Modules/Globalisation/GlobalisationApp";
import "./Modules/Globalisation/Services/MessageFormatInterpolation/MessageFormatInterpolationApp";

// GUI
import "./Modules/Gui/GuiApp";
import "./Modules/Gui/Filters/EnumFilters/EnumFiltersApp";
import "./Modules/Gui/Filters/SortingFilters/SortingFiltersApp";
import "./Modules/Gui/Filters/StringFilters/StringFiltersApp";
import "./Modules/Gui/Filters/TimeFilters/TimeFiltersApp";

// GUI Modules component directives
import "./Modules/Gui/Components/AlarmVideo/AlarmVideoDirective";
import "./Modules/Gui/Components/Image/ImageDirectives";

// GUI Modules components
import "./Modules/Gui/Components/ActionMenu/ActionMenuComponentApp";
import "./Modules/Gui/Components/AlarmVideo/AlarmVideoOverlayComponentApp";
import "./Modules/Gui/Components/Button/CancelButton/CancelButtonComponentApp";
import "./Modules/Gui/Components/Button/Common/ButtonComponentApp";
import "./Modules/Gui/Components/Button/DeleteButton/DeleteButtonComponentApp";
import "./Modules/Gui/Components/Button/EditButton/EditButtonComponentApp";
import "./Modules/Gui/Components/Button/SubmitButton/SubmitButtonComponentApp";
import "./Modules/Gui/Components/Card/CardComponentApp";
import "./Modules/Gui/Components/ConfirmationModal/ConfirmationModalComponentApp";
import "./Modules/Gui/Components/FeatureSwitcher/FeatureSwitcherComponentApp";
import "./Modules/Gui/Components/Filter/FilterComponentApp";
import "./Modules/Gui/Components/Icon/IconComponentApp";
import "./Modules/Gui/Components/Indicators/Error/ErrorComponentApp";
import "./Modules/Gui/Components/Indicators/Loading/LoadingComponentApp";
import "./Modules/Gui/Components/Indicators/LoadingError/LoadingErrorComponentApp";
import "./Modules/Gui/Components/ListGroup/ListGroupItemComponentApp";
import "./Modules/Gui/Components/LogoAnimation/LogoAnimationComponentApp";
import "./Modules/Gui/Components/PageLoadingOverlay/LoadingOverlayComponentApp";
import "./Modules/Gui/Components/PageLoadingOverlay/PageLoadingOverlayComponentApp";
import "./Modules/Gui/Components/PhoneNumberTypeLabel/PhoneNumberTypeLabelComponentApp";
import "./Modules/Gui/Components/Search/ExtendedSearchDetails/ExtendedSearchDetailsComponentApp";
import "./Modules/Gui/Components/Search/ExtendedSearchOverview/ExtendedSearchOverviewComponentApp";
import "./Modules/Gui/Components/Search/SearchComponentApp";
import "./Modules/Gui/Components/Search/SearchResultGroup/SearchResultGroupComponentApp";
import "./Modules/Gui/Components/Slider/SliderComponentApp";
import "./Modules/Gui/Components/StepIcon/StepIconComponentApp";
import "./Modules/Gui/Components/Tag/TagComponentApp";
import "./Modules/Gui/Components/UserInfoTable/UserInfoTableComponentApp";
import "./Modules/Gui/Components/Widgets/Dummy/DummyWidgetComponentApp";
import "./Modules/Gui/Components/Widgets/Sites/SitesWidgetComponentApp";
import "./Modules/Gui/Components/Widgets/SitesList/SitesListWidgetComponentApp";

// GUI Modules directives
import "./Modules/Gui/Directives/BindNewLines/BindNewLinesDirective";
import "./Modules/Gui/Directives/Ellipsis/EllipsisDirective";
import "./Modules/Gui/Directives/FocusOnInit/FocusOnInitDirective";
import "./Modules/Gui/Directives/HttpSrc/HttpSrcDirective";
import "./Modules/Gui/Directives/KendoGridModifier/KendoGridModifierDirective";
import "./Modules/Gui/Directives/Permission/PermissionDirective";
import "./Modules/Gui/Directives/SvgDraggable/SvgDraggableDirective";
import "./Modules/Gui/Directives/SvgIcon/SvgIconDirective";
import "./Modules/Gui/Directives/SvgImageCanvas/SvgImageCanvasDirective";
import "./Modules/Gui/Directives/SvgLine/SvgLineDirective";
import "./Modules/Gui/Directives/SvgPolygon/SvgPolygonDirective";
import "./Modules/Gui/Directives/Validation";
import "./Modules/Gui/Directives/Forms/InputComboBox/InputComboBoxDirective";
import "./Modules/Gui/Directives/Forms/InputDate/InputDateDirective";
import "./Modules/Gui/Directives/Forms/InputDateTime/InputDateTimeDirective";
import "./Modules/Gui/Directives/Forms/InputEmail/InputEmailDirective";
import "./Modules/Gui/Directives/Forms/InputMultiline/InputMultilineDirective";
import "./Modules/Gui/Directives/Forms/InputMultiselect/InputMultiselectDirective";
import "./Modules/Gui/Directives/Forms/InputNumber/InputNumberDirective";
import "./Modules/Gui/Directives/Forms/InputPassword/InputPasswordDirective";
import "./Modules/Gui/Directives/Forms/InputPath/InputPathDirective";
import "./Modules/Gui/Directives/Forms/InputPhone/InputPhoneDirective";
import "./Modules/Gui/Directives/Forms/InputSelect/InputSelectDirective";
import "./Modules/Gui/Directives/Forms/InputText/InputTextDirective";
import "./Modules/Gui/Directives/Forms/InputTextarea/InputTextareaDirective";
import "./Modules/Gui/Directives/Forms/InputToggle/InputToggleDirective";
import "./Modules/Gui/Directives/Forms/InputTypeahead/InputTypeaheadDirective";
import "./Modules/Gui/Directives/Forms/InputUnique/InputUniqueDirective";

// React Components
import "./ReactComponents";

// Components
import "./Components/About/AboutComponent";
import "./Components/AlarmCentralDialogs/AddOperatorStationToAlarmCentralComponent"; // still in use by React component "AlarmCentralDetails"
import "./Components/AlarmCentralDialogs/EditAlarmCentralInformationComponent"; // still in use by React component "AlarmCentralDetails"
import "./Components/AlarmCentralDialogs/EditOperatorStationComponent"; // still in use by React component "AlarmCentralDetails"
import "./Components/Companies/CompaniesComponent";
import "./Components/Companies/ReactWrapper/CompanyDetailsReactWrapper";
import "./Components/Core/Header/HeaderComponent";
import "./Components/Core/MainMenu/MainMenuComponent";
import "./Components/Dashboard/DashboardComponent";
import "./Components/Dashboard/FindUserByCode/FindUserByCodeComponent";
import "./Components/EquipmentFunctionalityType/EquipmentFunctionalityTypeComponent";
import "./Components/EquipmentType/EquipmentTypeComponent";
import "./Components/Login/LoginComponent";
import "./Components/Partners/AddPartner/AddPartnerComponent";
import "./Components/Partners/Details/AddPartnerUser/AddPartnerUserComponent";
import "./Components/Partners/Details/EditDataRetentionSettings/EditDataRetentionSettingsComponent";
import "./Components/Partners/Details/EditHolidays/EditHolidaysComponent";
import "./Components/Partners/Details/EditMindcareSettings/EditMindcareSettingsComponent";
import "./Components/Partners/Details/EditPartnerDetails/EditPartnerDetailsComponent";
import "./Components/Partners/Details/EditPartnerSettings/EditPartnerSettingsComponent";
import "./Components/Partners/Details/PartnerLabels/EditPartnerLabel/EditPartnerLabelPopupComponent";
import "./Components/Partners/Details/ReactWrapper/PartnerDetailsReactWrapper";
import "./Components/PartnerUser/Details/PartnerUserDetailsComponent";
import "./Components/Site/Activation/SiteActivationComponent";
import "./Components/Site/ConfigurationGroups/SiteConfigurationGroupsComponent";
import "./Components/Site/DesignAndPlanning/DesignAndPlanningComponent";
import "./Components/Site/Equipment/SiteEquipmentComponent";
import "./Components/Site/Events/EventsComponent";
import "./Components/Site/Events/EventsTable/EventsTableComponent";
import "./Components/Site/Events/EventsTable/EventsTableDetails/EventsTableDetailsComponent";
import "./Components/Site/Overview/Dashboard/SiteComponent";
import "./Components/Site/SiteLayout/SiteLayoutComponent";
import "./Components/Site/SystemsTesting/SystemsTestingComponent";
import "./Components/Site/UsersList/SiteUsersListComponent";
import "./Components/SitesList/SitesListComponent";
import "./Components/Team/TeamDetailsComponent";
import "./Components/Teams/AddTeam/AddTeamComponent";
import "./Components/TranslationKeys/TranslationKeysComponent";
import "./Components/Translations/TranslationsComponent";

// Directives
import "./Directives";
import "./Modules/Models/Directives/EnumFlag/EnumFlagDirective";
import "./Modules/Models/Directives/EnumFlagShow/EnumFlagShowDirective";

// Misc
import jsZip from "jszip";
import jq from "jquery";

type IrisWindow = Window &
    typeof globalThis & {
        $: typeof jq;
        JSZip: typeof jsZip;
    };

(window as IrisWindow).$ = jq;
(window as IrisWindow).JSZip = jsZip;
/* eslint-enable */
